<template>
  <div class="flex">
    <div class="">
      <div class="title">双堡气象站</div>
      <div class="qxz">
        <div class="flex alit qx-title">
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E6%97%B6%E9%97%B4%402x.png"
            alt=""
          />
          <div class="">当前时间:</div>
        </div>
        <div class="qx-data">
          <div class="text">{{ time }}</div>
        </div>
      </div>
      <div class="qxz">
        <div class="flex alit qx-title">
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E4%BD%9C%E7%89%A9%E5%BD%93%E5%89%8D%E9%98%B6%E6%AE%B5%402x.png"
            alt=""
          />
          <div class="">作物当前阶段：</div>
        </div>
        <div class="qx-data">
          <div class="text">{{ region.currentStage }}</div>
        </div>
      </div>
      <div class="qxz">
        <div class="flex alit qx-title">
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E6%B8%A9%E5%BA%A6%402x.png"
            alt=""
          />
          <div class="">当前温度(℃)：</div>
        </div>
        <div class="qx-data">
          <div class="text">{{ real.temp }}</div>
        </div>
      </div>
      <div class="qxz">
        <div class="flex alit qx-title">
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E6%B9%BF%E5%BA%A6%402x.png"
            alt=""
          />
          <div class="">当前湿度(%)：</div>
        </div>
        <div class="qx-data">
          <div class="text">{{ real.hum }}</div>
        </div>
      </div>
      <div class="qxz">
        <div class="flex alit qx-title">
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E5%9C%9F%E5%A3%A4%E6%B8%A9%E5%BA%A6%402x.png"
            alt=""
          />
          <div class="">当前土壤温度(℃)：</div>
        </div>
        <div class="qx-data">
          <div class="text">{{ need.inTemp }}</div>
        </div>
      </div>
      <div class="qxz">
        <div class="flex alit qx-title">
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E5%9C%9F%E5%A3%A4%E6%B9%BF%E5%BA%A6%402x.png"
            alt=""
          />
          <div class="">当前土壤湿度(%)：</div>
        </div>
        <div class="qx-data">
          <div class="text">{{ need.inHum }}</div>
        </div>
      </div>

      <div class="qxz">
        <div class="flex alit qx-title">
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8DET%E5%80%BC%402x.png"
            alt=""
          />
          <div class="">当前ET值(%)：</div>
        </div>
        <div class="qx-data">
          <div class="text">{{ real.etValue }}</div>
        </div>
      </div>
      <div class="qxz">
        <div class="flex alit qx-title">
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/24%E5%B0%8F%E6%97%B6%E5%86%85%E9%99%8D%E9%9B%A8%E6%A6%82%E7%8E%87%402x.png"
            alt=""
          />
          <div class="">24小时内降雨概率(%)：</div>
        </div>
        <div class="qx-data">
          <div class="text">{{ real.rainRate  }}</div>
        </div>
      </div>
    </div>
    <div class="" style="flex: 1">
      <div class="flex justb">
        <div class="title">甘州未来气象</div>
        <div class="flex">
          <div
            :class="checkDay == '3d' ? 'day-check' : 'day-default'"
            @click="(checkDay = '3d'), getHerald()"
          >
            近3天
          </div>
          <div
            :class="checkDay == '7d' ? 'day-check' : 'day-default'"
            @click="(checkDay = '7d'), getHerald()"
          >
            近一周
          </div>
          <div
            :class="checkDay == '15d' ? 'day-check' : 'day-default'"
            @click="(checkDay = '15d'), getHerald()"
          >
            近15天
          </div>
          <div
            :class="checkDay == '30d' ? 'day-check' : 'day-default'"
            @click="(checkDay = '30d'), getHerald()"
          >
            近一月
          </div>
        </div>
      </div>
      <div class="flexCol alit">
        <div class="yc flex alit">
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E6%B0%94%E8%B1%A1%E9%A2%84%E6%B5%8B%402x.png"
            alt=""
          />
          <div class="">气象预测</div>
        </div>
        <div class="flex justb" style="width: 100%">
          <div class="qxz">
            <div class="flex alit qx-title">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E6%B8%A9%E5%BA%A6%402x.png"
                alt=""
              />
              <div class="">最大温度(℃)：</div>
            </div>
            <div class="qx-data2">
              <div class="text">{{ herald.tempMax }}</div>
            </div>
          </div>
          <div class="qxz">
            <div class="flex alit qx-title">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E5%9C%9F%E5%A3%A4%E6%B8%A9%E5%BA%A6%402x.png"
                alt=""
              />
              <div class="">最小温度(℃)：</div>
            </div>
            <div class="qx-data2">
              <div class="text">{{ herald.tempMin }}</div>
            </div>
          </div>
          <div class="qxz">
            <div class="flex alit qx-title">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E6%B9%BF%E5%BA%A6%402x.png"
                alt=""
              />
              <div class="">湿度(%)：</div>
            </div>
            <div class="qx-data2">
              <div class="text">{{ herald.humidity }}</div>
            </div>
          </div>

          <!-- <div class="qxz">
            <div class="flex alit qx-title">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E5%9C%9F%E5%A3%A4%E6%B9%BF%E5%BA%A6%402x.png"
                alt=""
              />
              <div class="">平均土壤湿度：</div>
            </div>
            <div class="qx-data2">
              <div class="text">12:05</div>
            </div>
          </div> -->
          <div class="qxz">
            <div class="flex alit qx-title">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E8%92%B8%E8%85%BE%E9%87%8F%402x.png"
                alt=""
              />
              <div class="">降雨量(mm)：</div>
            </div>
            <div class="qx-data2">
              <div class="text">{{ herald.precip }}</div>
            </div>
          </div>
        </div>
        <div class="yc flex alit" style="margin-top: 2%">
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%A2%92%E6%83%85%E9%A2%84%E6%B5%8B%402x.png"
            alt=""
          />
          <div class="">墒情预测</div>
        </div>

        <div class="flex justb" style="width: 100%">
          <div class="qxz">
            <div class="flex alit qx-title">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E6%B8%A9%E5%BA%A6%402x.png"
                alt=""
              />
              <div class="">土壤温度(℃)：</div>
            </div>
            <div class="qx-data2">
              <div class="text">{{ herald.soilTemp }}</div>
            </div>
          </div>
          <div class="qxz">
            <div class="flex alit qx-title">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E6%B9%BF%E5%BA%A6%402x.png"
                alt=""
              />
              <div class="">土壤湿度(%)：</div>
            </div>
            <div class="qx-data2">
              <div class="text">{{ herald.soilHum }}</div>
            </div>
          </div>
          <div class="qxz">
            <div class="flex alit qx-title">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E5%9C%9F%E5%A3%A4%E6%B8%A9%E5%BA%A6%402x.png"
                alt=""
              />
              <div class="">土壤PH(%)：</div>
            </div>
            <div class="qx-data2">
              <div class="text">{{ herald.soilPH }}</div>
            </div>
          </div>
          <div class="qxz">
            <div class="flex alit qx-title">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%BD%93%E5%89%8D%E5%9C%9F%E5%A3%A4%E6%B9%BF%E5%BA%A6%402x.png"
                alt=""
              />
              <div class="">土壤电导率(µS/cm)：</div>
            </div>
            <div class="qx-data2">
              <div class="text">{{ herald.soilRate }}</div>
            </div>
          </div>
          <div class="qxz">
            <div class="flex alit qx-title">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E8%92%B8%E8%85%BE%E9%87%8F%402x.png"
                alt=""
              />
              <div class="">土壤ET(%)：</div>
            </div>
            <div class="qx-data2">
              <div class="text">{{ herald.etValue }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="title">AI辅助决策</div>
      <div class="aifx-title flex justb alit">
        <div class="" style="width: 16.5%">时间</div>
        <div class="" style="width: 16.5%">灌溉量(mm)</div>
        <div class="" style="width: 16.5%">区域</div>
        <div class="" style="width: 16.5%">设备</div>
        <div class="" style="width: 16.5%">状态</div>
        <div class="" style="width: 16.5%">操作</div>
      </div>
      <div class="cont">
        <div class="flex justb alit list" v-for="item in useRecard">
          <div class="" style="width: 16.5%">
            {{ utils.changeTimeNoHms(new Date()) }}
          </div>
          <div class="" style="width: 16.5%">{{ item.ggl }}</div>
          <div class="" style="width: 16.5%">{{ item.qy }}</div>
          <div class="" style="width: 16.5%">{{ item.sb }}</div>
          <div class="" style="width: 16.5%">{{ item.status }}</div>
          <div class="add-plan" style="width: 16.5%" @click="openPlan">
            加入执行计划
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    waterId: {
      type: String,
    },
  },
  data() {
    return {
      checkDay: "3d",
      time: "",
      region: null,
      need: null,
      real: null,
      herald: null,
      useRecard: [
        {
          ggl: "12",
          qy: "地块一",
          sb: "水肥一体化滴灌",
          status: "待执行",
        },
        {
          ggl: "19",
          qy: "地块二",
          sb: "水肥一体化滴灌",
          status: "待执行",
        },
        {
          ggl: "14",
          qy: "地块三",
          sb: "水肥一体化滴灌",
          status: "待执行",
        },
        {
          ggl: "10",
          qy: "地块四",
          sb: "水肥一体化滴灌",
          status: "待执行",
        },
      ],
    };
  },
  created() {
    // 每秒更新一次
    setInterval(this.updateClock, 1000);
    this.getRegion();
    this.getNeed();
    this.getReal();
    this.getHerald();
  },
  watch: {
    waterId() {
      this.getRegion();
      this.getNeed();
      this.getReal();
      this.getHerald();
    },
  },
  methods: {
    openPlan() {
      this.$confirm("该操作会执行灌溉作业，请谨慎操作", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            message: "暂无操作权限",
            type: "warning",
          });
        })
        .catch(() => {});
    },
    getHerald() {
      this.$request(`iot/screen/weather/getHerald?type=${this.checkDay}`).then(
        (res) => {
          console.log(res);
          this.herald = res.data;
        }
      );
    },
    getReal() {
      this.$request(`iot/screen/weather/getReal?id=${this.waterId}`).then(
        (res) => {
          console.log(res);
          this.real = res.data;
        }
      );
    },
    getNeed() {
      this.$request(`iot/screen/water/getNeed?id=${this.waterId}`).then(
        (res) => {
          console.log(res);
          this.need = res.data;
        }
      );
    },
    getRegion() {
      this.$request(`iot/screen/water/getRegion?id=${this.waterId}`).then(
        (res) => {
          console.log(res);
          this.region = res.data;
        }
      );
    },
    updateClock() {
      const now = new Date();
      // this.time = now.toLocaleTimeString();
      this.time = this.utils.changeTimeAll(now);
    },
  },
};
</script>

<style lang="scss" scoped>
.day-check {
  width: 70px;
  height: 40px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E6%97%B6%E9%97%B4%E9%80%89%E6%8B%A9%402x.png");
  background-size: 100% 100%;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 11px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  margin-right: -5px;
}
.day-default {
  width: 70px;
  height: 40px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E6%97%B6%E9%97%B4%E6%9C%AA%E9%80%89%E6%8B%A9%402x.png");
  background-size: 100% 100%;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 11px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  margin-right: -5px;
  cursor: pointer;
}
.add-plan {
  width: 100%;
  height: 40px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E6%95%88%E7%8E%87/%E5%8A%A0%E5%85%A5%E6%89%A7%E8%A1%8C%E8%AE%A1%E5%88%92%402x.png");
  background-size: 100% 100%;
  line-height: 40px;
  cursor: pointer;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 11px;
  color: #ffffff;
  text-align: center;
}
.title {
  margin: 10px 0;
}
/* 设置滚动条整体样式 */
.cont::-webkit-scrollbar {
  width: 8px;
  /* 垂直滚动条宽度 */
  height: 8px;
  /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
.cont::-webkit-scrollbar-track {
  background: rgba(202, 199, 199, 0.1);
  /* 轨道背景色 */
  border-radius: 4px;
  /* 圆角 */
}

/* 设置滚动条滑块 */
.cont::-webkit-scrollbar-thumb {
  background: #5d70db;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 圆角 */
}

/* 设置鼠标悬停在滑块上的样式 */
.cont::-webkit-scrollbar-thumb:hover {
  background: #5166db;
  cursor: pointer;
  /* 悬停时颜色 */
}
.cont {
  width: 810px;
  height: 260px;
  overflow-y: auto;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  background: rgba(248, 248, 248, 0.089);
  .list {
    height: 50px;
  }
}
.aifx-title {
  width: 800px;
  height: 36px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E6%A0%87%E9%A2%98%E6%A0%8F%402x.png");
  background-size: 100% 100%;

  font-weight: 500;
  font-size: 14px;
  color: #00ffd1;
  text-align: center;
}
.yc {
  margin: 0% 0 1% 0;
  img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
  font-family: JiangChengXieHei, JiangChengXieHei;
  font-weight: 900;
  font-size: 16px;
  color: #e6edf8;
}
.qxz {
  img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
  .qx-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin: 8px 0 5px 0;
  }
  .text {
    font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 20px;
    color: #f6f9fe;
    line-height: 40px;
    text-align: center;
    font-style: normal;
    text-decoration-line: underline;
    text-transform: none;
    background: linear-gradient(90deg, #ffffff 15%, #f7ff57 81%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .qx-data {
    width: 400px;
    height: 40px;
    background: rgba(10, 124, 190, 0.301);
    border-radius: 4px 4px 4px 4px;
  }
  .qx-data2 {
    width: 150px;
    height: 40px;
    background: rgba(10, 124, 190, 0.301);
    border-radius: 4px 4px 4px 4px;
  }
}
</style>